<template>
  <div class="tpl">
    <van-nav-bar title="订单列表" left-text="返回" right-text left-arrow fixed @click-left="onClickLeft" />
    <div style="height:46px"></div>
    <van-field v-model="receiverMobile" center clearable label="请输入手机号" placeholder="请输入手机号">
      <template #button>
        <van-button size="small" type="primary" v-on:click="getList()">点击获取订单</van-button>
      </template>
    </van-field>
    <div v-if="showLoading" style="margin-top:10px;background-color:#fff; display:flex; text-align:center" >
      <van-loading type="spinner" /><van-loading type="spinner" /><van-loading type="spinner" /><van-loading type="spinner" /><van-loading type="spinner" />
    </div>
    <div v-for="item in list" :key="item.id">
      <div style="background-color:#fff; margin-bottom:10px; padding:10px">
        <div style="line-height:30px">订单号：{{item.m.orderId}}</div>
        <div style="line-height:30px">
          总金额：
          <span style="color:red; padding-right:40px">¥{{item.m.totalPrice}}</span>
          <van-tag type="warning">{{item.m.orderStatusName}}</van-tag>
        </div>
        <div v-for="i in item.m.orderDetailList" :key="i.id" style="padding:10px; display:flex">
          <div style="width:50px; ">
            <van-image
              width="50px"
              height="50px"
              fit="contain"
              :src="'https://oss.lwljuyang.com/'+i.productMainImageKey"
            />
          </div>
          <div style="padding-left:10px">
            <div style="line-height:30px; height:30px; overflow:hidden">{{i.productName}}</div>
            <div>
              {{i.buyNum}}个 × {{i.payPrice}}元 = {{i.payPrice*i.buyNum}}元
              <span
                style="padding-left:20px"
              >{{i.specValue}}</span>
            </div>
          </div>
        </div>
        <div style="padding:10px 0 10px 0">下单时间：{{item.m.createOpeTime}}</div>
        <div style="padding:10px 0 10px 0">订单总金额：{{item.m.productMoney}} 订单配送费:{{item.m.freight}}</div>
        <div v-if="item.logisticsJson" class="wuliu">
          <div class="title" v-on:click="item.logisticsJson.isShow=!item.logisticsJson.isShow">
            物流信息:
            <van-icon v-if="!item.logisticsJson.isShow" name="arrow-down" />
            <van-icon v-if="item.logisticsJson.isShow" name="arrow-up" />
          </div>
          <div class="list" v-if="item.logisticsJson.isShow">
            <div v-for="w in item.logisticsJson.data" :key="w.id" style="margin-top:10px;">
              <div>{{w.time}}</div>
              <div style="padding-left:10px;">{{w.context}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="height:60px;"></div>
    <DPtabbar active="4"></DPtabbar>
  </div>
</template>
<script>
import Vue from "vue";
import { Tab, Tabs } from "vant";
import DPtabbar from "@/components/TabBar.vue";
import { Loading } from "vant";

Vue.use(Loading);
Vue.use(Tab);
Vue.use(Tabs);
export default {
  name: "orderList",
  components: {
    DPtabbar
  },
  data() {
    return {
      receiverMobile: "",
      list: [],
      showLoading: false
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },

    getList() {
      if(this.receiverMobile.length<6){
          this.$toast('请输入手机号');
          return;
      }
      this.list=[];
      this.showLoading = true;
      this.$http
        .post(
          "https://apis.lwljuyang.com/api-activity/activity/query",
          {
            receiver: "",
            receiverMobile:this.receiverMobile,
            token: "nvCyWYjmALyJ6pp9TSZlD3eymfyiLPKD",
            pageSize: 30,
            pageNo: 1,
            storeUuid: 123
          },
          {
            params: {},
            headers: {}
          }
        )
        .then(response => {
          this.showLoading = false;
          let data = response.body;
          // let d2=JSON.parse(data.data.retData)[0].logistics;
          let d = JSON.parse(data.data.retData);
          for (let i in d) {
            if (d[i].logistics != "") {
              d[i].logisticsJson = JSON.parse(d[i].logistics);
              d[i].logisticsJson.isShow = false;
            } else {
              d[i].logisticsJson = null;
            }
          }
          //   console.log(JSON.parse(d).data[0].time);
          if (data.resp_code == 0) {
            this.list = d;
            if(d.length==0){

                this.$toast('没有要查询的订单');
            }
          } else {
            this.$toast(data.resp_msg);
          }
        });
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.tpl {
  height: 100%;
  background-color: #f6f6f6;
  text-align: left;
}
.wuliu {
  .title {
    padding: 10px;
    background-color: #f6f6f6;
  }
  .list {
    padding: 10px;
  }
}
</style>